module.exports = __webpack_public_path__ + "media/images/admin/icons/zoom-in-0bd438a75f4b1c762f10b224b510eb4f.svg";